import React, { Component } from "react";
import PropTypes from "prop-types";
import { Container } from "../../../components/atoms/Container";
import { Section } from "../../../components/atoms/Section";
import GuidesPosts from "../../../components/atoms/GuidesPosts";
import BreadCrumbBar from "../../../components/atoms/BreadCrumbBar";
import { GUIDES_TAB_BAR_SLUG, GUIDES_TAB_HEADER_COLOR, GUIDES_TITLE_NAME } from "../../../helpers/constants";

import floatingEarth from "../../../assets/images/guides/floating-earth.png";

import GuidesHeader from "../../../components/molecules/GuidesHeader";
import urlPatterns from "../../../urls";
import { header } from "../../../styles/variables";
import GuidesTabNavigator from "../../../components/molecules/GuidesTabNavigator";

class GuidesTabRegion extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showBreadCrumbBar: true,
    };
  }

  async componentDidMount() {
    const { match, history, location } = this.props;
    const { params } = match || {};
    const { slug } = params || {};
    if (slug) {
      const { search } = location || {};
      history.push({
        pathname: urlPatterns.GUIDE_REGION_POST(slug),
        search,
      });
    }
  }

  render() {
    const { history, location } = this.props;

    const { showBreadCrumbBar } = this.state;

    return (
      <>
        <GuidesHeader
          headerIcon={floatingEarth}
          headerColor={GUIDES_TAB_HEADER_COLOR.GUIDE_REGION}
          headerTitle={GUIDES_TITLE_NAME.GUIDE_REGION}
          headerDescription="Wine is grown all over the world – learn about the different regions."
        />
        <GuidesTabNavigator
          mobileHeaderStyleTop={header.mobileHeight}
          shouldDisappearOnMobile
          backgroundColor={GUIDES_TAB_HEADER_COLOR.GUIDE_REGION}
          urlRegion={urlPatterns.GUIDE_REGION}
          location={location}
        />
        <Section xxs>
          {showBreadCrumbBar && (
            <BreadCrumbBar homeLabel="Guides" parentLabel="Region Guides" location={location} />
          )}
          <Container>
            <GuidesPosts
              history={history}
              filters={`${GUIDES_TAB_BAR_SLUG.GUIDE_REGION}`}
              metaTitle="A Guide to the Wine Regions of the World | Good Pair Days"
              metaDescription="Wine is grown all over the world – learn about the different
              regions here including the difference between Old World vs. New World wines."
              isFromTabRegion
              location={location}
            />
          </Container>
        </Section>
      </>
    );
  }
}

GuidesTabRegion.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  match: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({}).isRequired,
};

export default GuidesTabRegion;
